import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5 9q.233 0 .437.072.204.073.38.246l5.362 5.326q.321.318.321.81t-.32.81a1.1 1.1 0 0 1-.817.32 1.1 1.1 0 0 1-.816-.32L11.5 11.75l-4.547 4.515a1.1 1.1 0 0 1-.816.318 1.1 1.1 0 0 1-.816-.318 1.1 1.1 0 0 1-.321-.81q0-.493.32-.81l5.364-5.327q.175-.173.379-.246A1.3 1.3 0 0 1 11.5 9" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }